import styled, { css } from 'styled-components';
import { TrevorIcon } from '../TrevorIcon';
import { Label } from '../TypographyNew';

export const SelectButtonContainer = styled.button<{
  isFullWidth?: boolean;
  isSelected: boolean;
}>`
  position: relative;
  width: ${(p) => (p.isFullWidth ? '100%' : 'max-content')};
  display: flex;
  height: 48px;
  align-items: center;
  padding-inline: var(--spacing-l);
  padding-top: 8px;
  padding-bottom: 8px;
  background: var(--color-interface-neutral-light);
  border: 1px solid var(--color-brand-blue2-normal);
  ${(p) =>
    p.isSelected &&
    css`
      background: var(--color-feedback-success-lightest);
      border-color: var(--color-feedback-success-darker);
    `}
  border-radius: var(--radius-8);
  cursor: pointer;

  > span {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background: var(--color-interface-neutral-light);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: var(--spacing-s);
    flex-shrink: 0;
  }

  svg {
    flex-shrink: 0;
  }

  > p {
    text-align: start;
    margin-right: var(--spacing-s);
    overflow: hidden;
  }

  svg:first-child {
    margin: var(--spacing-s);
  }

  :has(svg:first-child) {
    padding-left: var(--spacing-s);
  }

  > input {
    border: none;
    outline: none;
    background: unset;
    width: inherit;
  }

  :hover {
    box-shadow: var(--elevation-soft);
  }

  :has(input:focus) {
    border: 1px solid var(--color-feedback-success-darker);
  }
`;

export const SelectButtonListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
`;

export const CheckCircle = styled(TrevorIcon).attrs({
  name: 'check-circle',
})<any>`
  color: ${(p) =>
    p.isSelected
      ? 'var(--color-feedback-success-darker)'
      : 'var(--color-interface-layout-normal)'};
  margin-left: auto;
`;

export const SelectButtonDynamicLabel = styled(Label).attrs({ variant: 1 })<{
  isTop: boolean;
  withIcon: boolean;
}>`
  white-space: nowrap;

  ${(p) =>
    p.isTop &&
    css`
      position: absolute;
      left: ${p.withIcon ? '48px' : '18px'};
      top: var(--spacing-xxs);
      font-weight: 500;
      font-size: 8px;
    `}
`;
